import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { skusQueryOptions } from '@/app/(client)/my-styles/-hooks/useSkusQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(list)/component-skus/archived/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      skusQueryOptions({ ...deps, isArchived: true, isComponent: true }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/ComponentSkusArchiveTab'),
    'ComponentSkusArchiveTab',
  ),
});
